import { Sparkle28Filled } from "@fluentui/react-icons";

export const AnswerIcon = () => {
    return <Sparkle28Filled primaryFill={"rgba(33, 234, 112, 1)"} aria-hidden="true" aria-label="Answer logo" />;
};
